






























































































import { onboardingStore } from "@/store/typed";
import { Vue, Component, Watch } from "vue-property-decorator";

const MAX_MESSAGE_HEIGHT = 100;

@Component
export default class CustomizerOnboarding extends Vue {
  private visible = true;

  private selectedStep = 0;

  private items = [
    {
      id: "back-button",
      position: "bottom",
      message: this.$t("onboarding.backButton"),
    },
    {
      id: "background-color-button",
      position: "bottom",
      message: this.$t("onboarding.bgButton"),
    },
    {
      id: "text-button",
      position: "bottom",
      message: this.$t("onboarding.textButton"),
    },
    {
      id: "image-button",
      position: "bottom",
      message: this.$t("onboarding.imgButton"),
    },
    {
      id: "emoji-button",
      position: "bottom",
      message: this.$t("onboarding.emojiButton"),
    },
    {
      id: "preview-button",
      position: "top",
      message: this.$t("onboarding.previewButton"),
    },
  ];

  setupFlowButton() {
    const message = document.getElementById("dynamic-help-message");
    const flowContainer = document.getElementById("onboarding-flow-container");

    const position = this.getDocumentOffsetPosition(message);
    const offset = MAX_MESSAGE_HEIGHT;

    flowContainer.style.top = `${position.top + MAX_MESSAGE_HEIGHT}px`;
    flowContainer.style.left = `${
      position.left - flowContainer.clientWidth / 2
    }px`;

  }

  get visibleItems() {
    return this.items.filter((o: any) => !o.hide);
  }

  incrementIndex() {
    if (this.selectedStep >= this.visibleItems.length - 1) {
      this.selectedStep = 0;
    } else {
      this.selectedStep++;
    }
  }

  decrementIndex() {
    if (this.selectedStep > 0) {
      this.selectedStep--;
    }
  }

  async mounted() {
    await this.$nextTick();
    this.selectedStep = 0;
    this.setupFlowButton();
    this.helpStyle(this.items[this.selectedStep]);
  }

  @Watch("selectedStep")
  onSelectedStep() {
    this.helpStyle(this.items[this.selectedStep]);
  }

  private hide() {
    this.visible = false;
    onboardingStore.setOnboarding(false);
  }

  get mobile(): boolean {
    return this.$mq === "sm" || this.$mq === "md" || this.$mq === "xs";
  }

  getDocumentOffsetPosition(el: any) {
    let top = 0,
      left = 0;
    while (el !== null) {
      top += el?.offsetTop || 0;
      left += el?.offsetLeft || 0;
      el = el?.offsetParent || null;
    }
    return { top, left };
  }

  helpStyle(item) {
    const el = document.getElementById(item.id);
    const positions = this.getDocumentOffsetPosition(el);
    const dynamicIndicatorEl = document.getElementById(
      "dynamic-help-message-indicator"
    );
    const dynamicIndicatorMessage = document.getElementById(
      "dynamic-help-message"
    );
    const spacing = 8;
    const verticalOffset =
      item.position == "top" ? -el.clientHeight : el.clientHeight;
    let indicator = "👆";
    switch (item.position) {
      case "bottom":
        indicator = "👆";
        break;
      case "top":
        indicator = "👇";
        break;
      case "left":
        indicator = "👉";
        break;
      case "right":
        indicator = "👈";
        break;
    }
    dynamicIndicatorEl.style.top = `${
      positions.top + verticalOffset + spacing
    }px`;
    dynamicIndicatorEl.style.left = `${positions.left + el.clientWidth / 3}px`;
    dynamicIndicatorEl.innerHTML = indicator;
    dynamicIndicatorMessage.innerHTML = item.message;
  }
}
